import { useMemo } from "react";

import { RolesActionItemForBulkActions } from "./types";
import useDeleteRolesBulkAction from "./useDeleteRolesBulkAction";

const useRolesBulkActions = (): RolesActionItemForBulkActions[] => {
  const confirmDeleteRolesBulkAction = useDeleteRolesBulkAction();

  return useMemo(() => [confirmDeleteRolesBulkAction], [confirmDeleteRolesBulkAction]);
};

export default useRolesBulkActions;
